
import { defineComponent, shallowRef } from 'vue'

// Composables
import { useDashboardManager } from '@/metrics/use-dashboards'

// Misc
import { requiredRule } from '@/util/validation'

export default defineComponent({
  name: 'DashboardYamlForm',

  setup(_props, ctx) {
    const isValid = shallowRef(true)
    const rules = {
      yaml: [requiredRule],
    }

    const yaml = shallowRef('')
    const dashboardMan = useDashboardManager()

    function saveYaml() {
      dashboardMan.createYaml(yaml.value).then((dashboard) => {
        ctx.emit('created', dashboard)
      })
    }

    return {
      isValid,
      rules,
      yaml,
      dashboardMan,

      saveYaml,
    }
  },
})
